import { useMemo, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "@application/store/useStore";
import { useDispatch } from "react-redux";
import { getRoleById } from "@reducers/roles/thunk/role-thunk";
const transformRoleDtoToRoleData = (roleDto) => {
    var _a;
    const claimsMap = new Map();
    (_a = roleDto.permissions) === null || _a === void 0 ? void 0 : _a.forEach((permission) => {
        var _a;
        const module = permission.key;
        const action = (_a = permission.value) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (!claimsMap.has(module)) {
            claimsMap.set(module, {
                module,
                viewPermission: false,
                createPermission: false,
                editPermission: false,
                deletePermission: false,
                serverSettingsPermission: false,
                nodeHardwareSettingsPermission: false,
            });
        }
        const claim = claimsMap.get(module);
        if (permission.isAllowed) {
            switch (action) {
                case "serversettings":
                    if (module === "AccessPoints")
                        claim.serverSettingsPermission = true;
                    break;
                case "hardwaresettings":
                    if (module === "Nodes")
                        claim.nodeHardwareSettingsPermission = true;
                    break;
                case "view":
                case "read":
                case "acknowledge":
                case "clear":
                case "generate":
                case "export":
                case "settings":
                case "logs":
                    claim.viewPermission = true;
                    break;
                case "create":
                    claim.createPermission = true;
                    break;
                case "edit":
                case "update":
                    claim.editPermission = true;
                    break;
                case "delete":
                    claim.deletePermission = true;
                    break;
            }
        }
    });
    return {
        id: roleDto.id || "",
        name: roleDto.name,
        description: "",
        usersInRole: roleDto.assignedUsersCount || 0,
        isActive: roleDto.isActive,
        roleClaims: Array.from(claimsMap.values()),
    };
};
export const useRoleData = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { roles, getRoleByIdLoading, selectedRole } = useAppSelector((state) => state.role);
    const isEdit = Boolean(id && id !== "new");
    useEffect(() => {
        if (isEdit && id) {
            const roleInStore = roles === null || roles === void 0 ? void 0 : roles.find((r) => r.id === id);
            if (!roleInStore || !selectedRole || selectedRole.id !== id) {
                dispatch(getRoleById(id));
            }
        }
    }, [id, isEdit, dispatch]);
    const role = useMemo(() => {
        if (!isEdit || !id)
            return null;
        const roleDto = ((selectedRole === null || selectedRole === void 0 ? void 0 : selectedRole.id) === id ? selectedRole : null) ||
            (roles === null || roles === void 0 ? void 0 : roles.find((r) => r.id === id));
        return roleDto ? transformRoleDtoToRoleData(roleDto) : null;
    }, [id, isEdit, roles, selectedRole]);
    const roleExists = isEdit ? Boolean(role) : true;
    const loading = getRoleByIdLoading && !role;
    return {
        isEdit,
        role,
        roleExists,
        loading,
    };
};
